import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {MULTIPLE_ACCOUNT_SELECT_ERROR} from 'src/modules/bulk-update/update-user-group/constants';
import {allSelectedUsersAccountsSelector} from 'src/modules/user-search-result';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';


import type {AppState} from 'src/store/typedef';

type Props = {
    userIds: number[],

    showUpdateGroup: boolean,
    openAssignToGroup: () => void,
    openDischargeFromGroup: () => void,

    showUpdateUserState: boolean,
    openUpdateUserStateTool: () => void,

    showUpdateUserNewsletter: boolean,
    openUpdateUserNewsletterTool: () => void,

    showUpdateUserAccount: boolean,
    openUpdateUserAccountTool: () => void,

    showUpdateLcdAnalysis: boolean,
    openSubscribeToLcdAnalysisTool: () => void,
    openUnsubscribeFromLcdAnalysisTool: () => void,
};

export const ToolsRow = (props: Props) => {
    const accountIds = useSelector((state: AppState) => allSelectedUsersAccountsSelector(state, props.userIds));
    const assignDisabled = useMemo(() => accountIds.length > 1, [accountIds]);

    return (
        <Group>
            {props.showUpdateGroup ? (
                <DropdownMenu
                    anchor={({positionRef, getAnchorProps, anchorRef}) => (
                        <FlatButton
                            endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                            {...getAnchorProps()}
                            ref={anchorRef}>
                            <b>Set Account Group</b>
                        </FlatButton>
                    )}>
                    <DropdownMenuItem
                        disabled={assignDisabled}
                        onClick={props.openAssignToGroup}
                        renderCaption={accountIds.length > 1
                            ? <span title={MULTIPLE_ACCOUNT_SELECT_ERROR}>Assign To Group</span>
                            : 'Assign To Group'}
                    />
                    <DropdownMenuItem
                        caption="Unassign From Group"
                        onClick={props.openDischargeFromGroup}
                    />
                </DropdownMenu>
            ) : null}
            {props.showUpdateLcdAnalysis ? (
                <DropdownMenu
                    anchor={({positionRef, getAnchorProps, anchorRef}) => (
                        <FlatButton
                            endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                            {...getAnchorProps()}
                            ref={anchorRef}>
                            <b>LCD Credit Analysis</b>
                        </FlatButton>
                    )}>
                    <DropdownMenuItem
                        caption="Subscribe"
                        onClick={props.openSubscribeToLcdAnalysisTool}
                    />
                    <DropdownMenuItem
                        caption="Unsubscribe"
                        onClick={props.openUnsubscribeFromLcdAnalysisTool}
                    />
                </DropdownMenu>
            ) : null}
            {props.showUpdateUserState ? (
                <FlatButton onClick={props.openUpdateUserStateTool}>
                    <b>Set User State</b>
                </FlatButton>
            ) : null}
            {props.showUpdateUserNewsletter ? (
                <FlatButton onClick={props.openUpdateUserNewsletterTool}>
                    <b>Set Newsletter Subscriptions</b>
                </FlatButton>
            ) : null}
            {props.showUpdateUserAccount ? (
                <FlatButton onClick={props.openUpdateUserAccountTool}>
                    <b>Change User's Account</b>
                </FlatButton>
            ) : null}
        </Group>
    );
};
